import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const TieringRoutes: Routes = [
  {
    path: "tiering",
    loadComponent: () =>
      import("./tiering/tiering.component").then((m) => m.TieringComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./tiering-list/tiering-list.component").then(
            (m) => m.TieringListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./tiering-form/tiering-form.component").then(
            (m) => m.TieringFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./tiering-form/tiering-form.component").then(
            (m) => m.TieringFormComponent,
          ),
      },
    ],
  },
];
